import React from "react";
import { useContext } from "react";

import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import AccordionContext from "react-bootstrap/AccordionContext";
import Card from "react-bootstrap/Card";

import "../../../styles/components/utils/components/ArrowCardToggle.scss";
import arrow from "../../../styles/images/arrow_black.svg";

function ArrowCardToggle({ children, eventKey, callback, showArr = true }) {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header id="arrowCardToggle" onClick={showArr ? decoratedOnClick : undefined}>
      {children}
      {showArr && <img className={isCurrentEventKey ? "arrow open" : "arrow"} src={arrow} alt="" />}
    </Card.Header>
  );
}

export default ArrowCardToggle;